import * as React from 'react';
import { UitkText } from 'uitk-react-text';
export var HeaderCurrencyDisplay = function (_a) {
    var currencies = _a.currencies;
    var currentCurrency = currencies.currentCurrency;
    if (!currentCurrency) {
        return null;
    }
    return (React.createElement(UitkText, null, currentCurrency.displayCurrency));
};
HeaderCurrencyDisplay.displayName = 'HeaderCurrencyDisplay';
//# sourceMappingURL=header-currency-display.js.map